module.exports = __webpack_public_path__ + "61316e67ad10a36bb50da239a1d6e32e.svg";